import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { SRVTableActionsMenu } from '../srv-table/SRVTableActionsMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export function SRVDatasetTableActionsBar(props) {
  return /*#__PURE__*/_jsx(TFlex, {
    justify: "end",
    padding: "200",
    children: /*#__PURE__*/_jsx(SRVTableActionsMenu, Object.assign({}, props))
  });
}